import { FC } from "react";
import CommonLayout from "../PageAddListing/CommonLayout";
import { useSelector } from "react-redux";
import { selectCurrentProperty } from "application/features/property/propertySlice";

export interface PageAddListingBorgoIntroProps {
  indexPage: string;
  backHref: string;
  nextHref: string;
}

const PageAddListingBorgoIntro: FC<PageAddListingBorgoIntroProps> = (
  { indexPage, backHref, nextHref }
) => {
  const property = useSelector(selectCurrentProperty);

  return (
    <CommonLayout
      index={indexPage}
      backtHref={backHref}
      nextHref={nextHref}
      canGoNext={true}
    >
      <>
        <h2 className="text-2xl font-semibold">Aggiungi i dettagli della destinazione</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className="mt-4">
          <p className="text-neutral-500 dark:text-neutral-400">
            Non abbiamo ancora informazioni sulla destinazione {property?.city}. 
            Aiutaci a creare una scheda informativa per questa località!
          </p>
          <p className="text-neutral-500 dark:text-neutral-400 mt-4">
            Nel prossimo step ti chiederemo alcune informazioni di base sulla località.
            Questo ci aiuterà a fornire informazioni utili ai futuri ospiti.
          </p>
        </div>
      </>
    </CommonLayout>
  );
};

export default PageAddListingBorgoIntro; 